import Column from './Column';
export default Column;
//# sourceMappingURL=index.js.map